import apiClient from "../services/apiClient";
import { ATP_API_URL } from "config/apiConfig";

export const sendEntityFormDataAction = async (payload) => {
  try {
    const response = await apiClient.post(
      ATP_API_URL.PRIMARY_CREATE_DATA,
      payload,
    );

    if (response.status === 200 && response.data?.success === true) {
      return {
        success: true,
        data: response,
      };
    } else {
      return {
        success: false,
        error: response.data?.message || "Failed to create entity",
      };
    }
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};
